import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store'
import { getTouristsVal } from '@/utils'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  linkExactActiveClass: 'active',
  linkActiveClass: 'link-active',
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },
  routes: [
    {
      path: '/proctoring-mini',
      name: 'go-proctor-mini',
      component: () => import('@/views/GoProctorMini.vue' /* webpackChunkName: "GoProctorMini" */)
    },
    {
      path: '/mental-auth',
      name: 'mental-auth',
      component: () => import('@/views/MentalAuth.vue' /* webpackChunkName: "MentalAuth" */)
    }
  ]
})

// 登录态判断
router.beforeEach(async (to, from, next) => {
  const isTourists = getTouristsVal()
  if (!isTourists) {
    if (to.meta.needLogin && !store.state.hasToken) {
      return next({ name: 'login' })
    } else {
      next()
    }
  } else {
    next()
  }
})

export default router
